export default "__VITE_ASSET__DtSHx2Mb__"